export default "__VITE_PUBLIC_ASSET__eb3857b8__"